<template>
  <div class="common-text-box-small mb-4">
    <div v-show="showTitle" class="flex items-center justify-start mb-2">
      <span class="mr-2">{{ title }}</span>
      <span v-show="required" class="required"> * </span>
    </div>
    <div
      :class="[isDrag ? dragoverClass : dragleaveClass]"
      @dragover.prevent="checkDrag($event, true)"
      @dragleave.prevent="checkDrag($event, false)"
      @drop.prevent="handleFileSelect($event)"
      @click="$refs.update_photo_input.click()"
    >
      <input
        type="file"
        ref="update_photo_input"
        class="hidden"
        @change="handleFileSelect($event)"
        multiple
      />
      <feather-icon
        svgClasses="h-6 w-6"
        icon="FileIcon"
        class="mb-2"
      ></feather-icon>
      <span>
        ファイルをドロップ、またはクリックしてファイルを選択し、追加
      </span>
      <div class="w-full">
        <div v-for="(file, index) in files" :key="index">
          <common-file-card
            :file="file"
            :deleteFile="deleteFile"
          ></common-file-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import CommonFileCard from "./CommonFileCard.vue";

export default {
  name: "M.CommonInputFile",
  mixins: [ColorMixin],
  components: { CommonFileCard },
  props: {
    title: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      inputValue: "",
      dragleaveClass: "drag-area-dragleave",
      dragoverClass: "drag-area-dragover",
      isDrag: false,
      isCrop: null,
      files: [],
      fileId: 1,
    };
  },
  methods: {
    handleFileSelect(e) {
      let _files = [];

      if ("files" in e.target) {
        _files = e.target.files;
      } else if ("files" in e.dataTransfer) {
        _files = e.dataTransfer.files;
      }

      _files.forEach(item => {
        const file = {};

        file.name = item.name;
        file.size = item.size;
        file.type = item.type;
        file.id = this.fileId;
        this.fileId = this.fileId + 1;

        let reader = new FileReader();
        reader.onload = _e => {
          file.src = _e.target.result;
          this.files.push(file);
        };
        reader.readAsDataURL(item);
      });
    },
    checkDrag(e, isDrag) {
      this.isDrag = isDrag;
    },
    deleteFile(id) {
      this.files = this.files.filter(item => {
        if (!item.id) return false;
        return item.id !== id;
      });
    },

    initFiles(files) {
      if (!files) {
        return;
      }
      this.files = files;
    },

    clearFiles() {
      this.files = [];
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-text-box-small {
  .required {
    color: $aisea-red;
  }
  .drag-area-dragleave {
    width: 100%;
    min-width: 120px;
    height: 100%;
    min-height: 100px;
    border: 2px dotted rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
    padding: 8px;
  }
  .drag-area-dragover {
    width: 100%;
    min-width: 200px;
    height: 100%;
    min-height: 200px;
    border: 2px solid $aisea-blue;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
    padding: 8px;
  }
}
</style>
